/* Rollkeen daily deal: live countdown to the store's midnight and a live
   "N left" count. Numbers come from the shop metafield via the
   hf-deal-state section; nothing here invents or animates a count. */
(() => {
  if (window.name === 'hf-rk-sink') return; // the hidden sign-up frame
  const roots = () => [...document.querySelectorAll('[data-hf-deal]')];
  if (!roots().length) return;
  const pad = n => String(n).padStart(2, '0');
  let end = Number(roots()[0].dataset.hfDealEnd) * 1000;

  function tick() {
    const ms = Math.max(0, end - Date.now());
    const s = Math.floor(ms / 1000);
    const txt = `${pad(Math.floor(s / 3600))}:${pad(Math.floor(s % 3600 / 60))}:${pad(s % 60)}`;
    document.querySelectorAll('[data-hf-deal-clock]').forEach(el => {
      if (el.textContent !== txt) el.textContent = txt;
    });
    if (ms === 0) { clearInterval(timer); setTimeout(() => location.reload(), 4000); }
  }

  function apply(st) {
    document.documentElement.dataset.hfDeal = st ? st.state : 'off'; // read by the add-to-cart "Wait!" pop-up
    if (!st || st.state === 'off') {
      // The feed went stale (reset missed): take every deal claim off the page.
      roots().forEach(r => r.remove());
      return;
    }
    end = st.end * 1000;
    roots().forEach(r => {
      r.dataset.state = st.state;
      r.querySelectorAll('[data-hf-deal-show]').forEach(el => { el.hidden = el.dataset.hfDealShow !== st.state; });
    });
    document.querySelectorAll('[data-hf-deal-left]').forEach(el => { el.textContent = st.left; });
    document.querySelectorAll('[data-hf-deal-noun]').forEach(el => { el.textContent = st.left === 1 ? 'spot' : 'spots'; });
    document.querySelectorAll('[data-hf-deal-verb]').forEach(el => { el.textContent = st.left === 1 ? 'There is' : 'There are'; });
    document.querySelectorAll('[data-hf-deal-fill]').forEach(el => { el.style.width = (st.cap ? Math.round(st.sold / st.cap * 100) : 0) + '%'; });
    document.querySelectorAll('.hf-deal__meter').forEach(el => el.setAttribute('aria-valuenow', st.sold));
    sticky(st.state === 'live' ? st.price : null);
    prices(st.state === 'live');
    ctas(st.state === 'live' ? st.price : null);
  }

  // The sticky add-to-cart bar prints the variant price; while the deal is live
  // it shows the deal price the checkout will actually charge.
  // Shea, 2026-09-25: always compare $119 to $49.50, so where the 2-pack is
  // on, the sticky bar and the buttons quote the per-sharpener 2-pack price.
  // 4 Oct 2026: it reads "from $49.50/ea", because one sharpener is $79.
  const eachEl = document.querySelector('[data-each]');
  const EACH = eachEl ? Number(eachEl.dataset.each) : 0;
  const REG = eachEl ? Number(eachEl.dataset.reg) : 0;
  let regular = null;
  function sticky(cents) {
    const el = document.querySelector('[data-stb-satc-price]');
    if (!el) return;
    if (regular === null) regular = el.textContent;
    const w = gated() ? ' with email' : '';
    if (EACH && cents) { el.innerHTML = `<s>${fmt(REG)}</s> from ${fmt(EACH)}/ea${w ? '<small>with email</small>' : ''}`; return; }
    el.textContent = cents ? fmt(cents) + (w || ' deal price') : regular;
  }

  // Until this browser has unlocked the deal with an email (snippets/hf-offer),
  // every deal price says so.
  const gated = () => !!document.querySelector('[data-hf-rk]') && !document.documentElement.classList.contains('hf-member');

  const fmt = c => '$' + (c / 100).toFixed(c % 100 ? 2 : 0);

  // Every price drawn by hf-deal mode 'price' follows the live state.
  function prices(live) {
    document.querySelectorAll('[data-hf-dp]').forEach(el => {
      const reg = Number(el.dataset.reg), deal = Number(el.dataset.deal), per = el.dataset.per || '', from = el.dataset.from || '';
      const on = live && deal > 0 && reg > deal;
      if (el.classList.contains('is-deal') === on && el.dataset.drawn) return;
      el.dataset.drawn = '1';
      el.classList.toggle('is-deal', on);
      el.innerHTML = on
        ? `<s class="hf-dp__was hf-sale__was" aria-label="Regular price ${fmt(reg)}">${fmt(reg)}</s> <span class="hf-dp__now hf-sale__now">${from}${fmt(deal)}${per}</span> <span class="hf-dp__tag"><span class="hf-m">deal price</span><span class="hf-g">with email</span></span>`
        : `<span class="hf-dp__now hf-sale__now">${fmt(reg)}</span>`;
    });
  }

  // Every button that sends someone to the sharpener, and the add-to-cart
  // button on its page, carries the deal price while the deal is live.
  const CTA_SEL = 'a.hf-btn[href*="/products/holdfast-rolling-knife-sharpener"], a.button[href*="/products/holdfast-rolling-knife-sharpener"], .hf-adv__btn, .product-form__submit';
  function ctas(cents) {
    const packs = document.querySelector('[data-hf-packs]');
    document.querySelectorAll(CTA_SEL).forEach(btn => {
      // The pack picker writes its own total into the add-to-cart button.
      if (packs && btn.matches('.product-form__submit')) return;
      // The bottom bar already shows the price beside its button.
      if (btn.closest('[data-stb-satc]')) return;
      let tag = btn.querySelector('.hf-dcta');
      if (!cents) { if (tag) tag.remove(); return; }
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'hf-dcta';
        (btn.querySelector('span:not(.loading__spinner):not(.hf-dcta)') || btn).appendChild(tag);
      }
      if (EACH) tag.innerHTML = `<span class="hf-dcta__sep"> \u00b7 </span><s>${fmt(REG)}</s> from ${fmt(EACH)}/ea${gated() ? ' with email' : ''}`;
      else tag.innerHTML = `<span class="hf-dcta__sep"> \u00b7 </span>${fmt(cents)} ${gated() ? 'with email' : 'deal price'}`;
    });
  }

  async function poll() {
    if (document.hidden) return;
    try {
      const r = await fetch(`/?section_id=hf-deal-state&t=${Date.now()}`, { credentials: 'same-origin' });
      const html = await r.text();
      const m = html.match(/<script type="application\/json" data-hf-deal-state>([\s\S]*?)<\/script>/);
      if (m) apply(JSON.parse(m[1]));
    } catch (e) { /* keep the last good numbers */ }
  }

  // The cart's "Deal price applied" line is a deal root too. It sits first in
  // the page and carries no price, so with the sharpener already in the cart
  // the bottom bar said $119 and the buttons lost their deal price until the
  // first poll (3 Oct). The price is read from the first root that has one.
  const priced = () => roots().find(r => r.dataset.price) || roots()[0];
  const first = priced();
  if (first.dataset.state === 'live' && first.dataset.price) {
    sticky(Number(first.dataset.price));
    ctas(Number(first.dataset.price));
  }
  document.addEventListener('hf:member', () => { const f = priced(); if (f && f.dataset.state === 'live' && f.dataset.price) { sticky(Number(f.dataset.price)); ctas(Number(f.dataset.price)); } });
  const timer = setInterval(tick, 1000);
  tick();
  setInterval(poll, 15000); // a real order moves the count on every open page within ~15s
  document.addEventListener('visibilitychange', () => { if (!document.hidden) poll(); });
})();
